import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrash2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} fill='none' {...props}>
    <path
      stroke='#F23645'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15.75 4.485a76 76 0 0 0-7.515-.375q-2.228 0-4.455.225l-1.53.15M6.375 3.728l.165-.983c.12-.712.21-1.245 1.478-1.245h1.964c1.268 0 1.366.563 1.478 1.253l.165.974M14.138 6.855l-.488 7.553c-.082 1.177-.15 2.092-2.242 2.092H6.592c-2.092 0-2.16-.915-2.242-2.092l-.488-7.553M7.748 12.375h2.497M7.125 9.375h3.75'
    />
  </svg>
);
export default SvgTrash2;
